import { defineComponent } from "vue";
import reloadSvg from "@/assets/images/svg/reload-icon.svg";
import ModalModule from "@/store/modules/modal";
import { ModalStatus } from "@/constants/modal";
export default defineComponent({
  name: "NavbarReloadConfig",
  setup: function setup() {
    var iconStyle = "filter: contrast(170%) invert(100%);";
    var iconContent = reloadSvg;
    var iconAlt = "reload";
    return {
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle
    };
  },
  methods: {
    // show the reload config modal
    reloadConfig: function reloadConfig() {
      ModalModule.setStatus(ModalStatus.ReloadConfiguration);
    }
  }
});